<div class="d-flex justify-content-evenly footer-container" *ngIf="displayedTab">
  <div *ngFor="let tab of displayedTab" class="w-100">
    <ng-container *ngIf="!tab.disabled; else disabled">
      <a *ngIf="!tab.disabled" [routerLink]="tab.path" routerLinkActive="active">
        <span class="icon coss-{{ tab.icon }}"></span>
        <span>{{ tab.label|translate }}</span>
      </a>
    </ng-container>
    <ng-template #disabled>
      <a *ngIf="tab.disabled" href="#" class="disabled">
        <span class="icon coss-{{ tab.icon }}"></span>
        <span>{{ tab.label|translate }}</span>
      </a>
    </ng-template>
  </div>
</div>